module.exports = __webpack_public_path__ + "static/img/ubg5.9f5bbef9.png";